export const estadosUF = [
    { estado: "Acre", sigla: "AC", codigo: "12" },
    { estado: "Alagoas", sigla: "AL", codigo: "27" },
    { estado: "Amapá", sigla: "AP", codigo: "16" },
    { estado: "Amazonas", sigla: "AM", codigo: "13" },
    { estado: "Bahia", sigla: "BA", codigo: "29" },
    { estado: "Ceará", sigla: "CE", codigo: "23" },
    { estado: "Distrito Federal", sigla: "DF", codigo: "53" },
    { estado: "Espírito Santo", sigla: "ES", codigo: "32" },
    { estado: "Goiás", sigla: "GO", codigo: "52" },
    { estado: "Maranhão", sigla: "MA", codigo: "21" },
    { estado: "Mato Grosso", sigla: "MT", codigo: "51" },
    { estado: "Mato Grosso do Sul", sigla: "MS", codigo: "50" },
    { estado: "Minas Gerais", sigla: "MG", codigo: "31" },
    { estado: "Pará", sigla: "PA", codigo: "15" },
    { estado: "Paraíba", sigla: "PB", codigo: "25" },
    { estado: "Paraná", sigla: "PR", codigo: "41" },
    { estado: "Pernambuco", sigla: "PE", codigo: "26" },
    { estado: "Piauí", sigla: "PI", codigo: "22" },
    { estado: "Rio de Janeiro", sigla: "RJ", codigo: "33" },
    { estado: "Rio Grande do Norte", sigla: "RN", codigo: "24" },
    { estado: "Rio Grande do Sul", sigla: "RS", codigo: "43" },
    { estado: "Rondônia", sigla: "RO", codigo: "11" },
    { estado: "Roraima", sigla: "RR", codigo: "14" },
    { estado: "Santa Catarina", sigla: "SC", codigo: "42" },
    { estado: "São Paulo", sigla: "SP", codigo: "35" },
    { estado: "Sergipe", sigla: "SE", codigo: "28" },
    { estado: "Tocantins", sigla: "TO", codigo: "17" },
];

export const cidadesUF = [
    { nome: "Maceió", codigo: "2704302" },
    { nome: "Manaus", codigo: "1302603" },
    { nome: "Feira de Santana", codigo: "2910800" },
    { nome: "Lauro de Freitas", codigo: "2919207" },
    { nome: "Salvador", codigo: "2927408" },
    { nome: "Vitória da Conquista", codigo: "2933307" },
    { nome: "Eusébio", codigo: "2304285" },
    { nome: "Fortaleza", codigo: "2304400" },
    { nome: "Maracanaú", codigo: "2307650" },
    { nome: "Águas Claras", codigo: "5300108" },
    { nome: "Brasília", codigo: "5300108" },
    { nome: "Ceilândia", codigo: "5300108" }, 
    { nome: "Gama", codigo: "5300108" },
    { nome: "Samambaia", codigo: "5300108" },
    { nome: "Santa Maria", codigo: "5300108" },
    { nome: "Taguatinga", codigo: "5300108" }, 
    { nome: "Cariacica", codigo: "3201308" },
    { nome: "Serra", codigo: "3205002" },
    { nome: "Vila Velha", codigo: "3205200" },
    { nome: "Vitória", codigo: "3205309" },
    { nome: "Anápolis", codigo: "5201108" },
    { nome: "Aparecida de Goiânia", codigo: "5201405" },
    { nome: "Goiânia", codigo: "5208707" },
    { nome: "Valparaíso", codigo: "5221858" },
    { nome: "São José de Ribamar", codigo: "2111201" },
    { nome: "São Luís", codigo: "2111300" },
    { nome: "Cuiabá", codigo: "5103403" },
    { nome: "Várzea Grande", codigo: "5108402" },
    { nome: "Campo Grande", codigo: "5002704" },
    { nome: "Belo Horizonte", codigo: "3106200" },
    { nome: "Betim", codigo: "3106705" },
    { nome: "Contagem", codigo: "3118601" },
    { nome: "Juiz de Fora", codigo: "3136702" },
    { nome: "Lagoa Santa", codigo: "3137601" },
    { nome: "Montes Claros", codigo: "3143302" },
    { nome: "Ribeirão das Neves", codigo: "3154606" },
    { nome: "Santa Luzia", codigo: "3157807" },
    { nome: "Sete Lagoas", codigo: "3167202" },
    { nome: "Uberaba", codigo: "3170107" },
    { nome: "Uberlândia", codigo: "3170206" },
    { nome: "Vespasiano", codigo: "3171204" },
    { nome: "Cabedelo", codigo: "2503209" },
    { nome: "Campina Grande", codigo: "2504009" },
    { nome: "João Pessoa", codigo: "2507507" },
    { nome: "Almirante Tamandaré", codigo: "4100400" },
    { nome: "Araucária", codigo: "4101804" },
    { nome: "Cambé", codigo: "4103701" },
    { nome: "Colombo", codigo: "4105805" },
    { nome: "Curitiba", codigo: "4106902" },
    { nome: "Londrina", codigo: "4113700" },
    { nome: "Maringá", codigo: "4115200" },
    { nome: "São José dos Pinhais", codigo: "4125506" },
    { nome: "Camaragibe", codigo: "2603454" },
    { nome: "Caruaru", codigo: "2604106" },
    { nome: "Jaboatão dos Guararapes", codigo: "2607901" },
    { nome: "Paulista", codigo: "2610707" },
    { nome: "Recife", codigo: "2611606" },
    { nome: "Teresina", codigo: "2211001" },
    { nome: "Belford Roxo", codigo: "3300456" },
    { nome: "Campos dos Goytacazes", codigo: "3301009" },
    { nome: "Duque de Caxias", codigo: "3301702" },
    { nome: "Itaboraí", codigo: "3301900" },
    { nome: "Macaé", codigo: "3302403" },
    { nome: "Nova Iguaçu", codigo: "3303500" },
    { nome: "Resende", codigo: "3304201" },
    { nome: "Rio das Ostras", codigo: "3304524" },
    { nome: "Rio de Janeiro", codigo: "3304557" },
    { nome: "São Gonçalo", codigo: "3304904" },
    { nome: "Volta Redonda", codigo: "3306305" },
    { nome: "Natal", codigo: "2408102" },
    { nome: "Parnamirim", codigo: "2403251" },
    { nome: "Canoas", codigo: "4304606" },
    { nome: "Caxias do Sul", codigo: "4305108" },
    { nome: "Gravataí", codigo: "4309209" },
    { nome: "Novo Hamburgo", codigo: "4313409" },
    { nome: "Porto Alegre", codigo: "4314902" },
    { nome: "São Leopoldo", codigo: "4318705" },
    { nome: "Sapucaia do Sul", codigo: "4320008" },
    { nome: "Viamão", codigo: "4323002" },
    { nome: "Biguaçu", codigo: "4202305" },
    { nome: "Blumenau", codigo: "4202404" },
    { nome: "Itajaí", codigo: "4208203" },
    { nome: "Joinville", codigo: "4209102" },
    { nome: "Palhoça", codigo: "4211900" },
    { nome: "São José", codigo: "4216602" },
    { nome: "Americana", codigo: "3501608" },
    { nome: "Araçatuba", codigo: "3502804" },
    { nome: "Araraquara", codigo: "3503208" },
    { nome: "Araras", codigo: "3503307" },
    { nome: "Barueri", codigo: "3505708" },
    { nome: "Bauru", codigo: "3506003" },
    { nome: "Birigui", codigo: "3506508" },
    { nome: "Botucatu", codigo: "3507506" },
    { nome: "Cajamar", codigo: "3509205" },
    { nome: "Campinas", codigo: "3509502" },
    { nome: "Catanduva", codigo: "3511102" },
    { nome: "Franca", codigo: "3516200" },
    { nome: "Guarulhos", codigo: "3518800" },
    { nome: "Hortolândia", codigo: "3519071" },
    { nome: "Itaquaquecetuba", codigo: "3523107" },
    { nome: "Itu", codigo: "3523909" },
    { nome: "Jacareí", codigo: "3524402" },
    { nome: "Jundiaí", codigo: "3525904" },
    { nome: "Limeira", codigo: "3526902" },
    { nome: "Marília", codigo: "3529005" },
    { nome: "Mogi das Cruzes", codigo: "3530607" },
    { nome: "Osasco", codigo: "3534401" },
    { nome: "Paulínia", codigo: "3536505" },
    { nome: "Piracicaba", codigo: "3538709" },
    { nome: "Poá", codigo: "3539806" },
    { nome: "Presidente Prudente", codigo: "3541406" },
    { nome: "Ribeirão Preto", codigo: "3543402" },
    { nome: "Santana de Parnaíba", codigo: "3547304" },
    { nome: "Santo André", codigo: "3547809" },
    { nome: "São Bernardo do Campo", codigo: "3548708" },
    { nome: "São Carlos", codigo: "3548906" },
    { nome: "São José do Rio Preto", codigo: "3549805" },
    { nome: "São José dos Campos", codigo: "3549904" },
    { nome: "São Paulo", codigo: "3550308" },
    { nome: "Sertãozinho", codigo: "3551702" },
    { nome: "Sorocaba", codigo: "3552205" },
    { nome: "Sta Bárbara do Oeste", codigo: "3545803" },
    { nome: "Taubaté", codigo: "3554102" },
    { nome: "Tremembé", codigo: "3554805" },
    { nome: "Votorantim", codigo: "3557006" },
    { nome: "Aracaju", codigo: "2800308" },
    { nome: "Barra dos Coqueiros", codigo: "2800605" },
    { nome: "Palmas", codigo: "1721000" }
];
